import AxiosConfig from '@/config/axios-config'

export const ContatoAPI = {

  enviarContato (nome, email, assunto, mensagem) {
    return AxiosConfig.secureJalekoAPI().post('/contato', { nome: nome, email: email, assunto: assunto, mensagem: mensagem }).then(response => response.data)
  }

}

export default ContatoAPI
